export default __webpack_public_path__ + "static/media/103.6d03cbb3.jpg";